const HeroSocials = () => {
    return (
        <>
        <div className="hero-social-elements d-none d-xxl-block">
        <div className="flp-text">
            <p>Follow Us</p>
        </div>
        <div className="long-arrow"></div>
       <div className="social-link">
  <a href="https://www.facebook.com/profile.php?id=61575105304065" target="_blank" rel="noopener noreferrer">
    <i className="fab fa-facebook-f"></i>
  </a>

  <a href="https://wa.me/9710502033924" target="_blank" rel="noopener noreferrer">
    <i className="fab fa-whatsapp"></i>
  </a>

  <a href="https://www.instagram.com/diamond_houseuae/" target="_blank" rel="noopener noreferrer">
    <i className="fab fa-instagram"></i>
  </a>

  <a href="https://www.linkedin.com/company/diamond-house-technical-services/posts/?feedView=all" target="_blank" rel="noopener noreferrer">
    <i className="fab fa-linkedin-in"></i>
  </a>
</div>
    </div>
        </>
    )
}

export default HeroSocials